import { Link } from 'react-router-dom';
import { useSession } from '../context/SessionContext';
import { GuestGate } from '../components/GuestGate';

export function Profile() {
  const { authenticated, profile, startKeyra } = useSession();

  if (!authenticated || !profile) {
    return (
      <>
        <main className="page">
          <p className="muted">Sign in with Keyra to view your profile.</p>
        </main>
        <GuestGate open onDismiss={() => window.history.back()} />
      </>
    );
  }

  return (
    <main className="page">
      <div className="creator-row" style={{ marginBottom: '1rem' }}>
        <span className="avatar" style={{ width: 48, height: 48, fontSize: '1rem' }}>
          {(profile.displayName ?? profile.username).slice(0, 1).toUpperCase()}
        </span>
        <div>
          <h1 style={{ margin: 0, fontFamily: 'var(--font-display)' }}>
            {profile.displayName ?? profile.username}
          </h1>
          <p className="muted" style={{ margin: 0 }}>
            @{profile.username}
          </p>
        </div>
      </div>
      <div className="row">
        <Link className="btn" to={`/channel/${profile.username}`}>
          View channel
        </Link>
        <Link className="btn" to="/library">
          Library
        </Link>
        <Link className="btn" to="/settings/ai">
          AI connections
        </Link>
        <button type="button" className="btn primary" onClick={() => void startKeyra()}>
          Continue with Keyra
        </button>
      </div>
    </main>
  );
}
